import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalDrawer: {
    defaultMessage: 'Import Units of Measure from CSV',
    id: 'kLInIC',
    description: 'Units of Measure Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    defaultMessage: 'Import Units of Measure',
    id: 'UadtQR',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    defaultMessage: 'Units of Measure Successfully Imported',
    id: 'RiQSoW',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  sku: {
    defaultMessage: 'SKU',
    id: '5L77HF',
    description: 'SKU product UOM import column name',
  },
  product_name: {
    defaultMessage: 'Product Name',
    id: 'OBU5TY',
    description: 'Product Name UOM import column name',
  },
  uom_type: {
    defaultMessage: 'UOM Type',
    id: 'M/cd7A',
    description: 'UOM Type (Each, Pack, Case, Pallet, Tote, Inner) import column name',
  },
  barcode: {
    defaultMessage: 'Barcode',
    id: '9NJ8e9',
    description: 'Barcode for this UOM level import column name',
  },
  conversion_factor: {
    defaultMessage: 'Conversion Factor',
    id: 'eZJ5DJ',
    description: 'Number of units of the previous UOM level that make up this level',
  },
  uom_sku: {
    defaultMessage: 'UOM SKU',
    id: 'OqbSn/',
    description: 'Optional SKU for this UOM level import column name',
  },
  uom_weight: {
    defaultMessage: 'UOM Weight',
    id: 'lujIDK',
    description: 'Weight of this UOM level import column name',
  },
  uom_length: {
    defaultMessage: 'UOM Length',
    id: 'aeUULK',
    description: 'Length of this UOM level import column name',
  },
  uom_width: {
    defaultMessage: 'UOM Width',
    id: 'zkbqBQ',
    description: 'Width of this UOM level import column name',
  },
  uom_height: {
    defaultMessage: 'UOM Height',
    id: '4Nxw1/',
    description: 'Height of this UOM level import column name',
  },
});
